import React, { PropsWithChildren } from 'react';

const PageLayoutHeader = ({
  children,
  // eslint-disable-next-line react/prop-types
  className = '',
  ...props
}: PropsWithChildren<React.ComponentPropsWithRef<'div'>>) => (
  <div className={`page-layout-header ${className}`} {...props}>
    {children}
  </div>
);

export default PageLayoutHeader;
